import './index.scss';

$(function () {
    const historyGoBackLinks = $('a.nr-history-link')
    historyGoBackLinks.click(function (e) {
        e.preventDefault()
        window.history.go(-1)
    })
})